module.exports = __webpack_public_path__ + "img/panama.72350675.svg";